var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29059 15.9859L7.26736 16C15.6508 14.524 12.5678 5.26027 22 3.57461C21.5791 3.47363 21.1411 3.3704 20.8865 3.33289C13.6506 2.26341 8.60187 4.64955 5.4456 8.99674L5.45033 8.99321C8.50524 8.8685 11.0691 8.23149 13.9563 6.659L14.0176 6.79685L13.8944 6.87508C11.1904 8.77809 8.12661 9.76294 4.97002 9.69017C3.78046 11.5172 2.89311 13.6475 2.29059 15.9859ZM21.7635 2.99307C20.686 2.28521 19.2523 1.51002 18.1174 1.13782C12.793 -0.606827 6.938 -0.663572 2.73995 3.24601C-0.994209 6.7244 -0.524004 11.4666 1.83775 15.4803L1.88164 15.555C2.05154 14.8016 2.25901 14.0576 2.50311 13.3321C2.55332 9.42633 4.29677 5.62606 7.39462 3.09117C7.42999 3.10078 7.45273 3.12034 7.46504 3.14663C5.13139 5.58086 3.8032 8.44404 3.16405 11.6313C4.54593 8.67294 6.22937 6.46408 8.71839 4.90442C9.68375 3.51338 10.6472 2.6401 12.3812 1.71263C12.4036 1.72674 12.4153 1.74501 12.4188 1.76681C11.359 2.542 10.5417 3.34796 9.66733 4.36166C10.5534 3.88366 11.3546 3.57269 12.4497 3.23351C15.1759 2.3894 18.3767 2.41216 21.7635 2.99307Z",
    fill: "#005AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.b9a646a2d332651a6671a5cb00b4a8ee.svg";
export { ForwardRef as ReactComponent };